import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-referal-list',
  templateUrl: './referal-list.component.html',
  styleUrls: ['./referal-list.component.scss']
})
export class ReferalListComponent {


  public loading:boolean = true;
  public DataListing:any=[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public confirmStatus: boolean = false;
  public Ids:any=''; 
  public sortType:any='desc';


  constructor(public router: Router, public service: GlobalService) { 
    this.getDetail(this.p);
  }

  ngOnInit(): void {
  }

  getDetail(page:any){
    var detail={
      page_no:page, limit:this.pageLimit,
      sortBy:'createdAt',
      sortOrder:this.sortType
    }; 
    this.service.PostApis(detail,'/user-referral-listing').subscribe(((response:any)=>{
      if(response.success==1){
        this.DataListing = response.data.record;
        this.totalCount = response.data.total;
        this.loading=false;
      } else {
        this.DataListing = [];
        this.totalCount = response.data.total;
        this.loading=false;
      }
    }))
  
  }

}
